export const sectionsMapper: Record<string, string> = {
  main: 'Главная',
  about: 'О застройщике',
  ratings: 'Рейтинги',
  awards: 'Награды',
  promos: 'Акции',
  projects: 'Объекты от застройщика',
  map: 'На карте',
  mortgage: 'Ипотека',
  video: 'Видео',
  news: 'Новости',
  instagram: 'Мы в instagram',
  documentation: 'Документация',
  ['other-developers']: 'Другие застройщики',
  benefits: 'Преимущества',
};
